import React from 'react';
import ToolTip from '../../Shared/ToolTip/ToolTip';

const RMDToolTip = ({ className }) => (
  <span className={className}>
    <ToolTip
      message={
        <div>
          Remaining RMD amount does not include any scheduled distributions
          using shares, percentage, or payment over number of years.
        </div>
      }
    />
  </span>
);

export default RMDToolTip;
